import logo from './logo.svg';
import './App.css';
import React, { useEffect, useState, Component } from 'react';
import axios from 'axios';
import { createBrowserHistory } from "history";
import { BrowserRouter, Router, Route, Routes } from "react-router-dom";
import Layout from "./constants/Layout"
import Orders from './components/Orders';
import Login from './components/Login';
import Openprint from './components/Openprint';
import Subprint from './components/Subprint';
import Iprint from './components/Iprint';
import Graphics from './components/Graphics';
import KyOpenprint from './components/KentuckyOp';
import OpOpenOrdersPage from './components/OpOpenOrdersPage';
import SpOpenOrdersPage from './components/SpOpenOrdersPage';
import ShippingPerformancePage from './components/ShippingPerformancePage';
import { ToastContainer } from 'react-toastify';


const history = createBrowserHistory();

function App() {
  const [getMessage, setGetMessage] = useState({})

  // useEffect(()=>{
  //   axios.get('http://localhost:5000/flask/test').then(response => {
  //     console.log("SUCCESS", response)
  //     setGetMessage(response)
  //   }).catch(error => {
  //     console.log(error)
  //   })

  // }, [])


  return (
    <React.Fragment>
      <BrowserRouter location={history.location} navigator={history}>
        <Routes>
        
          {/* <Route path="/auth" component={NoLayoutRouter} /> */}
          <Route path="/" element={ <Login /> } />
        
          <Route path="/printverse" element={ <Orders /> } />

          <Route path="/openprint" element={ <Openprint /> } />

          <Route path="/openprint/orders" element={ <OpOpenOrdersPage tab="total" /> } />

          <Route path="/openprint/orders/today" element={ <OpOpenOrdersPage tab="today" /> } />

          <Route path="/openprint/orders/errors" element={ <OpOpenOrdersPage tab="errors" /> } />

          <Route path="/openprint/orders/shipped" element={ <OpOpenOrdersPage tab="shipped" /> } />

          {/* <Route path="/openprint/orders/incoming" element={ <OpOpenOrdersPage tab="incoming" /> } /> */}

          <Route path="/openprint/orders/allorders" element={ <OpOpenOrdersPage tab="allorders" /> } />

          <Route path="/openprint/orders/next-business-day" element={ <OpOpenOrdersPage tab="nextday" /> } />

          <Route path="/openprint/orders/mug-boxes" element={ <OpOpenOrdersPage tab="mugboxes" /> } />

          <Route path="/openprint/orders/puzzle-boxes" element={ <OpOpenOrdersPage tab="puzzleboxes" /> } />

          <Route path="/openprint/shipping-performance" element={ <ShippingPerformancePage /> } />

          <Route path="/subprint" element={ <Subprint /> } />

          <Route path="/subprint/orders" element={ <SpOpenOrdersPage tab="total" /> } />

          <Route path="/subprint/orders/allorders" element={ <SpOpenOrdersPage tab="allorders" /> } />

          <Route path="/subprint/orders/errors" element={ <SpOpenOrdersPage tab="errors" /> } />

          <Route path="/subprint/orders/shipped" element={ <SpOpenOrdersPage tab="shipped" /> } />

          <Route path="/subprint/orders/next-business-day" element={ <SpOpenOrdersPage tab="nextday" /> } />

          <Route path="/subprint/orders/mug-boxes" element={ <SpOpenOrdersPage tab="mugboxes" /> } />

          <Route path="/iprint" element={ <Iprint /> } />

          <Route path="/graphics" element={ <Graphics /> } />

          <Route path="/kentuckyop" element={ <KyOpenprint /> } />
      
        </Routes>
        <ToastContainer pauseOnFocusLoss={false} />
      </BrowserRouter>
    </React.Fragment>
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Testing React + Flask
    //     </p>
    //     <div>{getMessage.status === 200 ? 
    //       <h3>{getMessage.data.message}</h3>
    //       :
    //       <h3>LOADING</h3>}
    //     </div>
    //   </header>
    // </div>
  );
}

export default App;
